import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div style="text-align: justify;">
			<p class="mb-3">
				Какое счастье быть свободным! 
			</p>
			
			<p class="mb-5">
				Как радостно бьют в камень волны, разбиваясь в лёгкую светлую пену, врастают в него и снова падают; 
				и белое и лёгкое становится твёрдым и зелёным, и опять взлетает вверх, и сила волн выражается в радости брызг. 
			</p>
			
			
			<p class="text-center bold mb-5">* * *</p>
			
			
			<p class="mb-3">
				И вот мы прилетели в страну, о которой грезили во сне. 
				Колышущееся море деревьев, серое небо над ним – простор и ощущение огромной силы, величия: эта страна тебе по плечу, эта страна для тебя. 
			</p>
			
			<p class="mb-3">
				Упругий тёплый ветер встретил нас, когда мы спустились вниз. 
				Мы пролетели над деревьями и сошли у моря. 
				Серые волны бились в охристый берег. 
				Никого не было вокруг. 
			</p>
			
			<p class="mb-3">
				Мы пошли вдоль берега. 
				За первым поворотом открылась деревня. 
				Дома были покрыты чем-то вроде блестящей слюды. 
				Стены серые и шершавые. 
				У уреза воды лежали лодки, обычные рыбацкие лодки, тяжёлые и широкие. 
				Но не было видно сохнущих сетей. 
				В деревне не было деревьев, не было палисадников и огородов у дома, только дома и лодки. 
				Не было ни собак, ни скота. 
				Ни души. 
				В домах не было окон. 
				Только двери, деревянные, тёмные, закрытые. 
			</p>
			
			<p class="mb-3">
				Мы подошли к дому и постучали в дверь. 
				Никто не ответил нам. 
				Тишина царила в деревне. 
			</p>
			
			<p class="mb-3">
				Мы сели на берег и стали ждать.
			</p>
			
			<p class="mb-3">
				Через некоторое время на реке появилась лодка. 
				В неё был впряжён коричневый рыб или что-то вроде дельфина: блестящее тело с плавниками, быстро несущееся по воде. 
				Гладкая упряжь плотно облегала его.
			</p>
			
			<p class="mb-3">
				То, что сидело в лодке, было высоким, коричневым, похожим на дерево. 
				На верхней части у него росло что-то зелёное, как волосы на голове или листья на дереве. 
				Рук было много. 
				Тремя он держал упряжь (вправо, влево и вперёд), а остальные были опущены вниз. 
				Ниже уровня зелёного на «голове» находился полупрозрачный голубовато-зеленоватый пояс, окружавший весь ствол; он всё время как бы темнел, 
				светлел и переливался. 
				Пока будем называть это «световым поясом», хотя потом появилась идея, что это «глаза с обзором 360º» или что-то вроде панорамного экрана.
			</p>
			
			<p class="mb-3">
				Увидев (или почуяв? или услышав? или почувствовав в радио- или каком-то неведомом для нас диапазоне?) нас, 
				он выронил поводья из рук, и животное сразу же остановилось. 
				В верхнем световом поясе заплясали, заполыхали вспышки, направленные на нас; мы замерли, не зная, как реагировать на это. 
				Было это приветствие, осмотр, вопрос? «Дуб» остановился и вышел из лодки. 
			</p>
			
			<p class="mb-3">
				Поскольку всё встреченное нами было непривычно и непонятно, мы стали называть всё привычными словами, 
				чтоб иметь возможность хоть как-то описывать увиденное. 
				Мы надеялись, что потом, овладев языком этих мест, мы сможем пользоваться их словами для описания их вещей; но всё оказалось совсем не так. 
			</p>
			
			<p class="mb-3">
				У них не было слов: понятия передавались световыми импульсами, которые обрабатывались непосредственно в световом поясе, безо всякой передачи в «мозг» внутри. 
				Никакого мозга не было: всё взаимодействие с миром осуществлялось через свет; «сон» для переработки информации происходил в темноте: 
				поэтому дома были тёмные и без окон. 
				Они служили только для отдыха и восстановления системы. 
				Период обращения этой планеты был чрезвычайно долог, и с развитием «цивилизации», т.е. с возрастанием разума, 
				её обитатели просто не успевали обрабатывать полученную за «день» информацию и стали умирать от «солнечного удара» вследствие переполнения вместилища; 
				ну как бы у нас разорвался мочевой пузырь, если бы мы многие сутки пили без его опорожнения. 
			</p>
			
			<p class="mb-3">
				К тому времени разумная жизнь, зародившаяся здесь не в животном, а в растительном мире, уже могла покидать свой субстрат и передвигаться по поверхности «земли». 
				Корни превратились в «ходительные ноги» (их тоже было отнюдь не две, что позволяло передвигаться быстро и в любом направлении), 
				а ветви – в столь же многофункциональные «руки». 
				Но что им было делать на этой планете? 
				Питание они, как и флора у нас, получали от солнечного света; передвигаться по твёрдой поверхности легко могли с помощью многочисленных крепких «ног», 
				расположенных не линейно, а радиально, что позволяло с такой же лёгкостью ходить по горам, как и по гладкой «земле». 
				Чтобы передвигаться по воде, они приручили рыб; дома-укрытия и лодки стали строить из тел умерших соплеменников.
			</p>
			
			<p class="mb-3">
				Умирали они обычно от старости, когда истирались ноги, истрёпывалась и увядала листва, разрушались клетки светового пояса. 
				Сезоны на этой планете были не очень выражены, поэтому обитатели были «вечнозелёными»; листва их опадала не вразу, а понемножку, 
				и с возрастом их клетки, как и у всех живых организмов, старели и разрушались.
			</p>
			
			<p class="mb-3">
				Это была идеальная экологическая планета: никто никого не ел, не было соперничества за пищу, свет был доступен всем, даром. 
				В воде животные и низшие водные растения жили как обычно: выстраивались пищевые цепи, но в результате саморегуляции всё развивалось своим порядком, 
				и кризисы если и появлялись, то сами впоследствии и разрешались. 
				Единственно, больших рыбов «они» приручили для своих нужд: передвигаться по воде. 
				Но <b>как</b> они их приручили? 
				Для чего им надо было передвигаться? 
				Чем они вообще занимались?
			</p>
			
			<p class="mb-3">
				Это было самое интересное; но много ли мы смогли понять? 
				Как их вообще называть? 
				В среднем, они довольно высокие; но будем называть их «кустами» для краткости. 
				Наш куст, увидев, что мы не понимаем его знаков, протянул к нам свои весьма жёсткие руки-ветви, обхватил нас и повлёк к открытой двери одного из домов. 
				Вышел, закрыв за собой дверь… 
				Мы кинулись к ней – она оказалась без замков – и увидели, что он разнуздал и отпустил рыба, вытянул на берег лодку и вернулся к нам, 
				уже немного отошедшим от дома. 
				Снова взял нас в охапку, внёс в дом и остался вместе с нами, загородив дверь одной очень твёрдой жёсткой веткой.
			</p>
			
			<p class="mb-3">
				Мы оказались в полной темноте; и тут мы увидели то, что происходило с ним и что дало нам представление, в чём же был смысл развития на этой планете. 
				В темноте светился только пояс у него на «голове»; там яркие вспышки сменялись плавными переливами глубоких тонов: синего, оранжевого, пурпура… 
				потом эти переливы стали оформляться в какие-то фигуры, картины; и вдруг мы увидели себя, стоящих на берегу! 
				Потом замелькало много различных кустов и деревьев на разных фонах: в горах, на холмах, у моря, в лодках… 
				И вдруг из его «пояса» вышел яркий световой луч и как игла пронзил наш мозг. 
				Или это было два луча? 
				Ведь на его световом поясе появились изображения и меня, и её. 
				Эпизоды из нашей прошлой жизни (наших жизней!) сменялись один за другим: но поскольку он не двигался с места, 
				на этом кольцевом экране мы могли видеть только то, что было спереди; поэтому много мы пропустили. 
				Очень ясно мы увидели последние дни перед отлётом; и мы снова пережили те же чувства, что влекли нас с оставленной Земли в дальний космос, 
				в поисках одиночества и свободы. 
				И болью пронзило нас, и грустью, и вдруг поняли мы, что никуда не убежали от себя, и везде будем мы волочить за собой наши несбывшиеся надежды, 
				мечты и желания, и нет нам места ни на Земле, ни в небесах.
			</p>
			
			<p class="mb-3">
				И остались мы на этой планете, ибо некуда нам идти, и из сухих веток от трупов сделали себе удочки и сачочки, и стали ловить мелких рыб да креветок, 
				жарить их да варить, благо веток было много. 
				На нас приходили поглазеть аборигены, приводили детей познакомиться с инопланетной фауной… 
				Отрастить себе световой пояс мы не могли, поэтому общение было только односторонним: они спрашивали нас о чём-то и считывали ответы из наших мозгов; 
				они считывали также и наши вопросы, но часто не отвечали: слишком разными были наши жизненные системы. 
			</p>
			
			<p class="mb-3">
				Они ничего не создавали, не строили, кроме лодок и «тёмных домов»; в их цивилизации не было ничего материального. 
				Живущие светом и воздухом, они не знали конфликтов и не имели стремлений; они растворялись в бесконечном счастье свободы и покоя. 
				Если они хотели, они врастали корнями в землю, где им нравилось; размножались они отводками, отламывая их от себя и втыкая в грунт. 
				Никакого разделения полов, никакой заботы о детях. 
				Точнее, забота была, но не о личных, а о детях вообще: обычно отводки сажали в определённом месте, т.н. школке, и если долго не было дождей, 
				они своими жёсткими ногами прорывали арыки к морю (океан у них пресный). 
				Ни родственных, ни половых чувств. 
			</p>
			
			<p class="mb-3">
				У них была культура; они обменивались какими-то творениями, смысл которых я так и не уловил: это была музыка и драма переливающихся красок, 
				но наш человеческий мозг не мог этого понять и воспринять. 
				Иногда там мелькали наши образы; но что́ они думали о нас, я не знаю.
			</p>
			
			<p class="mb-5">
				Я пишу «я», потому что моя подруга скоро умерла. 
				У неё прекратились менструации, она не могла есть одну рыбу, худела, высыхала, стала терять память и скоро угасла. 
				Твёрдой веткой я выкопал могилу. 
				Всё это очень заинтересовало аборигенов: в то время часто наши изображения появлялись на их «поясах»; потом на её могилу стали сходиться посетители… 
				Но внезапно всё это резко исчезло с экранов – и я не знаю, просто ли они потеряли интерес – или поставили у себя какой-то блок, чтобы мне этого не было видно. 
				Я ведь так и не понял, чем они занимаются и о чём думают. 
				Солнце, воздух, свобода и бесконечная игра, искусство, сочинение музыки и драмы из бесконечно переливающихся красок, цветовых пятен, создание новых миров, 
				в одиночку или совместно; переплетающихся, тающих и возникающих миров, вселенская игра богов…
			</p>
			
			
			<p class="text-center bold mb-5">* * *</p>
			
			
			<p class="mb-3">
				Однако эти шустрые деревья заметили, что там, где останавливалась эта пара (а потом и даже один человек), грунт становился более плодородным; 
				и в этих местах появились новые школки, а аборигены охотно укоренялись там для отдыха и восстановления сил… 
			</p>
			
			<p class="mb-3">
				Когда он умер, ему тоже выкопали могилу, и она тоже вскоре стала весьма посещаемым местом. 
				Места, где проходила жизнь этой пары, так и стали называть: «след человека»; 
				и два безвестных скитальца внесли свой вклад в одну из высочайших цивилизаций Вселенной простым удобрением её почвы. 
			</p>
			
			<p class="mb-3">
				Так вклад Человека занял своё законное место в развитии культурной жизни Космоса. 
			</p>
		</div>
		`
	)
}

const itemName = {
	rus: `О космическом рае`
}

const itemDate = {
	rus: `3 мая 2024 г.`
}

const item = {
	itemlink: getLink(itemName.rus.replace('...', '')),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;